import { Action } from 'redux';
import { BrandColor } from '@dev/ee-api/ee-api-models';

export enum ActionTypes {
    LOAD_START = '@@brandColors/LOAD_START',
    LOAD_SUCCESS = '@@brandColors/LOAD_SUCCESS',
    LOAD_ERROR = '@@brandColors/LOAD_ERROR',
    ADD_START = '@@brandColors/ADD_START',
    ADD_SUCCESS = '@@brandColors/ADD_SUCCESS',
    ADD_ERROR = '@@brandColors/ADD_ERROR',
    EDIT_START = '@@brandColors/EDIT_START',
    EDIT_SUCCESS = '@@brandColors/EDIT_SUCCESS',
    EDIT_ERROR = '@@brandColors/EDIT_ERROR',
    DELETE_START = '@@brandColors/DELETE_START',
    DELETE_SUCCESS = '@@brandColors/DELETE_SUCCESS',
    DELETE_ERROR = '@@brandColors/DELETE_ERROR',
}

export interface BrandColorsLoadAction extends Action {
    type: ActionTypes.LOAD_START;
}

export interface BrandColorsLoadSuccessAction extends Action {
    type: ActionTypes.LOAD_SUCCESS;
    payload: { colors?: BrandColor[] };
}

export interface BrandColorsLoadErrorAction extends Action {
    type: ActionTypes.LOAD_ERROR;
}

export interface BrandColorsAddStartAction extends Action {
    type: ActionTypes.ADD_START;
    payload: { color: BrandColor };
}

export interface BrandColorsAddSuccessAction extends Action {
    type: ActionTypes.ADD_SUCCESS;
    payload: { colors: BrandColor[] };
}

export interface BrandColorsAddErrorAction extends Action {
    type: ActionTypes.ADD_ERROR;
    payload: { color: BrandColor };
}

export interface BrandColorsEditStartAction extends Action {
    type: ActionTypes.EDIT_START;
    payload: { colorIndex: number; color: BrandColor };
}

export interface BrandColorsEditSuccessAction extends Action {
    type: ActionTypes.EDIT_SUCCESS;
    payload: { colors: BrandColor[] };
}

export interface BrandColorsEditErrorAction extends Action {
    type: ActionTypes.EDIT_ERROR;
    payload: { color: BrandColor };
}

export interface BrandColorsDeleteStartAction extends Action {
    type: ActionTypes.DELETE_START;
    payload: { colorIndex: number; color: BrandColor };
}

export interface BrandColorsDeleteSuccessAction extends Action {
    type: ActionTypes.DELETE_SUCCESS;
    payload: { colors: BrandColor[] };
}

export interface BrandColorsDeleteErrorAction extends Action {
    type: ActionTypes.DELETE_ERROR;
    payload: { color: BrandColor };
}

export interface BrandColorsState {
    list?: BrandColor[];
    isLoading: boolean;
    isLoaded: boolean;
    isError: boolean;
}
